export const REGISTERED_EVENTS_SEARCH_ENDPOINT = 'api/v1/registered_events/search';

export const DEVICE_TYPE_ENTITY = 'DEVICE_TYPE';

export const OPERATOR_TRIGGER_CATALOGUE_UNAVAILABLE_KEY =
    'settings.operator-custom-notifications.form.notifications.triggers-unavailable';
